import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_KeepAlive, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(
        _ctx.isMobilecp
          ? 'DashboardBrandManagementMobile'
          : 'DashboardBrandManagement'
      )))
  ], 1024))
}